var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1033Etagenodermehr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 403.568,
    width: 403.568,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(24 160.57804870605497,413.0986022949218)",
    id: "svg_26",
    height: 52.593,
    width: 229.485,
    y: 386.802,
    x: 45.836,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-25 344.66613769531216,412.09716796874994)",
    id: "svg_27",
    height: 51.426,
    width: 229.485,
    y: 386.384,
    x: 229.924,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-22 119.07975006103533,354.9759826660156)",
    id: "svg_28",
    height: 41.998,
    width: 134.01,
    y: 333.977,
    x: 52.075,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-152 213.2183380126953,384.9315185546875)",
    id: "svg_30",
    height: 85.261,
    width: 160.215,
    y: 342.301,
    x: 133.111,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-25 294.76989746093733,380.57427978515625)",
    id: "svg_29",
    height: 68.482,
    width: 160.215,
    y: 346.333,
    x: 214.663,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-158 403.0012817382813,358.1132202148438)",
    id: "svg_31",
    height: 41.998,
    width: 134.01,
    y: 337.114,
    x: 335.996,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-158 466.8937377929687,375.2343139648438)",
    id: "svg_32",
    height: 24.963,
    width: 28.323,
    y: 362.753,
    x: 452.732,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-158 45.081592559814446,375.44488525390625)",
    id: "svg_33",
    height: 24.963,
    width: 25.26,
    y: 362.963,
    x: 32.452,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-152 210.8654022216797,255.51976013183594)",
    id: "svg_34",
    height: 85.261,
    width: 160.215,
    y: 212.889,
    x: 130.758,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-22 116.7267990112304,224.77989196777347)",
    id: "svg_35",
    height: 41.998,
    width: 134.01,
    y: 203.781,
    x: 49.722,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-158 51.76620101928712,247.16520690917972)",
    id: "svg_36",
    height: 24.963,
    width: 39.679,
    y: 234.683,
    x: 31.927,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(24 163.71530151367188,283.6868286132812)",
    id: "svg_37",
    height: 52.593,
    width: 229.485,
    y: 257.39,
    x: 48.973,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-25 345.45046997070307,281.90109252929693)",
    id: "svg_38",
    height: 51.426,
    width: 229.485,
    y: 256.188,
    x: 230.708,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-158 468.3330993652344,243.5836944580078)",
    id: "svg_39",
    height: 24.963,
    width: 33.12,
    y: 231.102,
    x: 451.773,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-126 392.2391052246094,128.60821533203125)",
    id: "svg_50",
    height: 123.171,
    width: 40.561,
    y: 67.023,
    x: 371.959,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-158 398.29541015625,224.77989196777347)",
    id: "svg_40",
    height: 41.998,
    width: 134.01,
    y: 203.781,
    x: 331.291,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-25 296.33853149414045,249.59390258789062)",
    id: "svg_41",
    height: 68.482,
    width: 160.215,
    y: 215.353,
    x: 216.231,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-25 303.09509277343756,133.9735107421875)",
    id: "svg_43",
    height: 110.741,
    width: 160.215,
    y: 78.603,
    x: 222.988,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-117 147.2190093994141,78.57975769042969)",
    id: "svg_46",
    height: 123.171,
    width: 41.945,
    y: 16.994,
    x: 126.246,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-25 210.54606628417972,94.75782775878903)",
    id: "svg_44",
    height: 110.741,
    width: 160.215,
    y: 39.387,
    x: 130.439,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-140 53.336673736572266,112.09249114990236)",
    id: "svg_47",
    height: 35.569,
    width: 32.566,
    y: 94.308,
    x: 37.054,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(24 169.20549011230483,151.9221496582031)",
    id: "svg_42",
    height: 52.593,
    width: 229.485,
    y: 125.626,
    x: 54.463,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-67 319.4615173339843,87.99459838867188)",
    id: "svg_45",
    height: 183.007,
    width: 88.926,
    y: -3.509,
    x: 274.998,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-117 420.1506958007812,130.9636077880859)",
    id: "svg_49",
    height: 123.171,
    width: 24.711,
    y: 69.378,
    x: 407.795,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_3",
    d: "m506.306998,106.01883l-246.858,-100.572c-2.21,-0.9 -4.688,-0.9 -6.897,0l-246.859,100.572c-3.395,1.384 -5.636,4.66 -5.692,8.325c-0.058,3.664 2.078,7.009 5.426,8.498l246.858,109.715c1.183,0.526 2.449,0.788 3.714,0.788c1.266,0 2.531,-0.262 3.714,-0.788l246.858,-109.715c3.348,-1.489 5.484,-4.834 5.426,-8.498c-0.054,-3.665 -2.295,-6.941 -5.69,-8.325zm-250.307,108.177l-223.523,-99.343l223.523,-91.065l223.523,91.065l-223.523,99.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_6",
    d: "m506.306998,234.02083l-104.032,-42.385c-4.674,-1.904 -10.011,0.34 -11.915,5.018c-1.906,4.676 0.341,10.011 5.018,11.916l84.146,34.284l-223.524,99.343l-223.523,-99.343l81.909,-33.372c4.676,-1.906 6.924,-7.241 5.018,-11.918c-1.902,-4.676 -7.239,-6.919 -11.915,-5.018l-101.796,41.475c-3.395,1.383 -5.636,4.659 -5.692,8.324c-0.058,3.664 2.078,7.009 5.426,8.498l246.858,109.715c1.183,0.526 2.449,0.788 3.714,0.788c1.266,0 2.531,-0.262 3.714,-0.788l246.858,-109.715c3.348,-1.489 5.484,-4.834 5.426,-8.498c-0.054,-3.665 -2.295,-6.941 -5.69,-8.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_24",
    d: "m506.306998,367.35416l-104.032,-42.385c-4.674,-1.904 -10.011,0.34 -11.915,5.018c-1.906,4.676 0.341,10.011 5.018,11.916l84.146,34.284l-223.524,99.343l-223.523,-99.343l81.909,-33.372c4.676,-1.906 6.924,-7.241 5.018,-11.918c-1.902,-4.676 -7.239,-6.919 -11.915,-5.018l-101.796,41.475c-3.395,1.383 -5.636,4.659 -5.692,8.324c-0.058,3.664 2.078,7.009 5.426,8.498l246.858,109.715c1.183,0.526 2.449,0.788 3.714,0.788c1.266,0 2.531,-0.262 3.714,-0.788l246.858,-109.715c3.348,-1.489 5.484,-4.834 5.426,-8.498c-0.054,-3.665 -2.295,-6.941 -5.69,-8.324z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1033Etagenodermehr);
export default __webpack_public_path__ + "static/media/103 3 Etagen oder mehr.b29e7ccaea09b723482293c681385f7b.svg";
export { ForwardRef as ReactComponent };